module.exports = __webpack_public_path__ + "static/media/HDJN08.9dc46903.jpg";